"use client";

import { useTranslation } from "react-i18next";
import FAQSection from "@/components/sections/FAQSection";
import PitchPageHero from "@/components/pitches/PitchPageHero";
import PitchGallery from "@/components/pitches/PitchGallery";
import PitchVenueDetails from "@/components/pitches/PitchVenueDetails";
import PitchAboutSection from "@/components/pitches/PitchAboutSection";
import PitchPricingSection, {
  type PitchPricingRow,
} from "@/components/pitches/PitchPricingSection";

const GALLERY_IMAGES = [
  "/new/DSC_2833-2.jpg",
  "/new/DSC_3234-2.jpg",
  "/new/Foto (28).jpg",
  "/new/Foto (66).jpg",
];

const PRICING_DATA: PitchPricingRow[] = [
  { timeKey: "pricingPage.table.luVi712", regular: 40000, vip10: 36000, vip15: 34000 },
  { timeKey: "pricingPage.table.luVi1218", regular: 58000, vip10: 52200, vip15: 49300 },
  { timeKey: "pricingPage.table.luVi1801", regular: 72000, vip10: 64800, vip15: 61200 },
  { timeKey: "pricingPage.table.sab712", regular: 40000, vip10: 36000, vip15: 34000 },
  { timeKey: "pricingPage.table.sab1201", regular: 72000, vip10: 64800, vip15: 61200 },
  { timeKey: "pricingPage.table.dom712", regular: 40000, vip10: 36000, vip15: 34000 },
  { timeKey: "pricingPage.table.dom1201", regular: 72000, vip10: 64800, vip15: 61200 },
];

export default function ParquetFutsal5Page() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white pb-20">
      <PitchPageHero
        eyebrowKey="chips.parquet"
        titleKey="canchaPitchPage.titleParquet"
        descriptionKey="chooseCards.card1Desc"
        shareTitleKey="chooseCards.card1Title"
        ratingScore={5}
        reviewCount={112}
      />

      <div className="mx-auto w-full max-w-6xl px-4 sm:px-6">
        <PitchGallery images={GALLERY_IMAGES} />

        <PitchVenueDetails sportsDescription={t("canchaDetails.parquetSports")} />

        <PitchAboutSection>
          <span className="mb-3 block">{t("canchaPitchPage.parquetAboutP1")}</span>
          <span className="mb-3 block">{t("canchaPitchPage.parquetAboutP2")}</span>
          <span className="mb-2 mt-6 block font-semibold text-slate-800">
            {t("canchaPitchPage.parquetRulesTitle")}
          </span>
          <span className="block">- {t("canchaPitchPage.parquetRule1")}</span>
          <span className="block">- {t("canchaPitchPage.parquetRule2")}</span>
          <span className="block">- {t("canchaPitchPage.parquetRule3")}</span>
        </PitchAboutSection>

        <PitchPricingSection
          rows={PRICING_DATA}
          pricingSubtitle={t("canchaPitchPage.pricingSubtitleParquet", {
            timeLabel: t("pricingPage.table.time"),
          })}
        />
      </div>

      <div className="mt-20">
        <FAQSection />
      </div>
    </div>
  );
}
